module.exports = __webpack_public_path__ + "img/renzhizhineng.a1f2b8f6.png";